import L from 'leaflet';

// Fix for default marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export const createColorIcon = (color) => {
    // Create a canvas element
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = 25;
    canvas.height = 41;

    // Draw marker shape
    ctx.beginPath();
    ctx.moveTo(12.5, 41);
    ctx.lineTo(0, 15);
    ctx.quadraticCurveTo(0, 0, 12.5, 0);
    ctx.quadraticCurveTo(25, 0, 25, 15);
    ctx.lineTo(12.5, 41);
    ctx.closePath();

    // Fill with custom color
    ctx.fillStyle = color;
    ctx.fill();

    // Add border
    ctx.strokeStyle = '#000';
    ctx.lineWidth = 1;
    ctx.stroke();

    // Convert to data URL
    const dataUrl = canvas.toDataURL();

    return new L.Icon({
        iconUrl: dataUrl,
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
    });
};

export const availableColors = {
    blue: '#3B82F6',
    red: '#EF4444',
    green: '#10B981',
    yellow: '#F59E0B',
    purple: '#8B5CF6',
    pink: '#EC4899',
    orange: '#F97316',
    teal: '#14B8A6',
    cyan: '#06B6D4',
    lime: '#84CC16'
};
